export default {
  siteName: 'Kiuki',
  siteUrl: 'https://kiuki.com'
}
